/* src/app/forms/produtos/mercadolivre/meli-edit-form/meli-category-predictor/meli-category-predictor.component.scss */
.container {
  padding: 20px;
}
.detail {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}
.card {
  flex: 0 0 calc(35% - 16px);
  max-width: calc(35% - 16px);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  background: var(--tem-surface, #fff);
  padding: 14px 16px;
  transition: box-shadow 0.3s;
}
.card:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.4);
}
@media (max-width: 599px) {
  .card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
.card-header {
  margin-bottom: 8px;
  min-width: 0;
}
.card-title {
  font-weight: 600;
  font-size: var(--tem-fs-md, 14px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card-subtitle {
  color: var(--tem-muted, rgba(0, 0, 0, 0.54));
  font-size: var(--tem-fs-sm, 12px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.card-content {
  flex: 1;
}
.tags ul {
  margin: 0;
  padding-left: 18px;
  font-size: var(--tem-fs-sm, 12px);
}
.tags li {
  overflow-wrap: anywhere;
}
/*# sourceMappingURL=meli-category-predictor.component.css.map */
